export const ADDITIONAL_FREIGHT_TABS_ENTITLEMENT = "additional_tabs@freight";